module.exports = __webpack_public_path__ + "img/close.fc4c7c58.png";